import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { IEscrowBankAccountResponse } from '../../types/accounting/response/IEscrowBankAccountResponse';
import { IEscrowBankAccountData } from '../../types/accounting/data/IEscrowBankAccountData';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';

export const getEscrowBankAccountsAsync = async (): Promise<IEscrowBankAccountData[]> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IEscrowBankAccountResponse[]>('/timber/api/internal/escrow/bank_accounts')
    .then((response) => response.data)
    .catch(axiosErrorHandler);
